import { useCallback, useState, type ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { ErrorBoundary } from './ErrorBoundary'

/** Aísla una página/sección: si su árbol lanza una excepción de render, solo esa página cae
 * -- el resto de la Mini App (nav inferior, otras páginas) sigue funcionando. "Reintentar"
 * incrementa `resetCount`, que se pasa como `key` del `ErrorBoundary`: React desmonta y
 * vuelve a montar el árbol entero de la página (nunca recarga Telegram), lo que además hace
 * que cualquier consulta de TanStack Query que hubiera quedado en error se vuelva a ejecutar
 * al montar un nuevo observer. */
export function PageBoundary({ page, children }: { page: string; children: ReactNode }) {
  const navigate = useNavigate()
  const [resetCount, setResetCount] = useState(0)

  const handleRetry = useCallback(() => setResetCount((c) => c + 1), [])
  const handleGoHome = useCallback(() => navigate('/'), [navigate])

  return (
    <ErrorBoundary key={resetCount} page={page} onRetry={handleRetry} onGoHome={handleGoHome}>
      {children}
    </ErrorBoundary>
  )
}
